import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	InputNumber,
	Button,
	Table,
	Modal,
	Steps,
	Divider,
	Image,
	Popconfirm,
	Radio,
	Result,
	Select,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	CommonConfig,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	parseTime,
	getQuery,
	httpPost
} from '@/utils/Tools';
import AddGoodsOrder from '@/components/AddGoodsOrder';

const {Column} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'goodsId':0,
			
			'userInfo':{},
			'siteUrl':'',
			'categoryList':[],
			'info':{
				'goods_thumb':{},
				'goods_spec':[],
				
				'spec_index':0,
				'quantity':1,
			},
			
			'orderInfo':{
				'order_amount':0,
				'total_amount':null,
				'shipping_method':10,
			},
			'showOrderDialog':false,
		};
	}
	
	componentDidMount()
	{
		this.state.goodsId = this.props.match.params.id;
		let siteUrl = CommonValue.get('site_url');
		this.state.siteUrl = siteUrl;
		
		this.getCategoryList();
		this.getInfo();
		this.setState({
			'userInfo':CommonValue.get('user_info'),
		});
		document.title = '展示器材 - ' + CommonValue.get('site_name');
	}
	
	getCategoryList()
	{
		let url = pcUrl('goods','categoryList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'categoryList':data,
				});
			});
	}
	
	getInfo()
	{
		let url = pcUrl('goods','detail');
		let param = {
			'goods_id':this.state.goodsId,
		};
		httpPost(url,param)
			.then(data=>{
				data['spec_index'] = 0;
				data['quantity'] = 1;
				//转换goods_spec的格式
				data['goods_spec'].forEach((row)=>{
					if(row[3].length)
					{
						let temp = {};
						row[3].forEach(row1=>{
							temp[row1[0]] = {
								'goods_price':row1[1],
								'goods_points':row1[2],
							};
						});
						row[3] = temp;
					}
				});
				this.setState({
					'info':data,
				});
				document.title = data['goods_name'] + ' - ' + document.title;
			});
	}
	
	quantityMinus()
	{
		let info = this.state.info;
		if(info.quantity == 1) return;
		info.quantity -- ;	
		this.setState({
			'info':info,
		});
	}
	
	quantityChange(val)
	{
		if(val != +val || val <= 0) return;
		
		let info = this.state.info;
		
		let goodsStorage = +this.state.info['goods_storage'];
		if(this.state.info['goods_spec'].length)
		{
			goodsStorage = +this.state.info['goods_spec'][this.state.info['spec_index']][2];
		}
		if(+val > goodsStorage) return;
		
		info.quantity = val;
		this.setState({
			'info':info,
		});
	}
	
	quantityPlus()
	{
		let info = this.state.info;
		let goodsStorage = +this.state.info['goods_storage'];
		if(this.state.info['goods_spec'].length)
		{
			goodsStorage = +this.state.info['goods_spec'][this.state.info['spec_index']][2];
		}
		if(info.quantity >= goodsStorage) return;
		
		info.quantity ++ ;
		this.setState({
			'info':info,
		});
	}
	
	showOrder()
	{
		//获取价格
		let url = pcUrl('goods','calcPrice');
		let param = {
			'goods_ids':this.state.goodsId,
			'spec_index_list':this.state.info['spec_index'],
			'quantity_list':this.state.info['quantity'],
		};
		
		httpPost(url,param)
			.then(data=>{
				let userInfo = CommonValue.get('user_info');
				
				let selectedGoodsList = [];
				let goodsInfo = JSON.parse(JSON.stringify(this.state.info));
				let goodsId = goodsInfo['goods_id'];
				//计算商品价格
				if(goodsInfo['goods_spec'])
				{
					goodsInfo['goods_price'] = goodsInfo['goods_spec'][goodsInfo['spec_index']][1];
					goodsInfo['goods_spec'] = goodsInfo['goods_spec'][goodsInfo['spec_index']][0];
				}
				goodsInfo['goods_price'] = data[goodsId]['goods_price'];
				goodsInfo['goods_amount'] = data[goodsId]['goods_amount'];
				goodsInfo['pay_amount'] = data[goodsId]['pay_amount'];
				selectedGoodsList.push(goodsInfo);
				
				let orderInfo = this.state.orderInfo;
				orderInfo['order_amount'] = data.total;
				
				this.setState({
					'showOrderDialog':true,
				},()=>{
					this.addGoodsOrder.init({
						'userInfo':userInfo,
						'selectedGoodsList':selectedGoodsList,
						'orderInfo':orderInfo,
						'orderCurrent':0,
					});
					/*
					this.getCouponList();
					this.getMethodList();
					*/
				});
				
				/*
				this.setState({
					'userInfo':userInfo,
					'selectedGoodsList':selectedGoodsList,
					'orderInfo':orderInfo,
					'showOrderDialog':true,
					'orderCurrent':0,
				});
				this.getCouponList();
				this.getMethodList();
				*/
			});
	}
	
	render()
	{
		return (
			<div className="bg-gray">
				<div className="body">
					<div className="height-20"></div>
					<div className="goods-left">
						<div className="category-list">
							<ul>
								{this.state.categoryList.map((row,index)=>(
									<li> <a href="javascript:;" className={this.state.info['category_id'] == row['category_id'] ?'now':''} onClick={()=>this.props.history.push('/goodsList?id='+row['category_id'])}>{row['category_name']}</a> </li>
								))}
							</ul>
						</div>
					</div>
					<div className="goods-right">
						<div className="goods-detail">
							<div className="height-5"></div>
							<div className="ur-here">
								您当前的位置：
								<a href={this.state.siteUrl}>首页</a>
								&gt;
								<a href="javascript:;" onClick={()=>this.props.history.push('/goodsList?id='+this.state.info['category_id'])}>{this.state.info['category_name']}</a>
								&gt;
								<span>{this.state.info['goods_name']}</span>
							</div>
							<div className="height-5"></div>
							<div className="goods-head">
								<div className="goods-thumb">
									<Image width={300} src={this.state.info['goods_thumb']['thumb_name']} preview={{ src:this.state.info['goods_thumb']['image_name'] }} />
								</div>
								<div className="goods-desc">
									<h1>{this.state.info['goods_name']}</h1>
									{this.state.info['goods_spec'].length ? (
										<p className="spec-list">
											规格：
											&nbsp;&nbsp;
											{this.state.info['goods_spec'].map((row,index)=>(
												<a href="javascript:;" className={index == this.state.info['spec_index'] ? 'now':''} onClick={()=>{let info = this.state.info; info['spec_index'] = index; this.setState({'info':info})}}>{row[0]}</a>
											))}
											&nbsp;
											<span>
												（库存{this.state.info['goods_spec'][this.state.info['spec_index']][2]}）
											</span>
										</p>
									):(
									<p>
										库存：
										&nbsp;&nbsp;
										{this.state.info['goods_storage']}
									</p>
									)}
									<p>
										数量：
										&nbsp;&nbsp;
										<span className="quantity-select">
											<button className="button button-border" onClick={()=>this.quantityMinus()}> - </button>
											<input className="input-text" value={this.state.info['quantity']} onChange={e=>this.quantityChange(e.target.value)} />
											<button className="button button-border" onClick={()=>this.quantityPlus()}> + </button>
										</span>
									</p>
									<p>
										价格：
										&nbsp;&nbsp;
										{this.state.info['goods_spec'].length ? (
											<span className="goods-price">
											￥
											{this.state.info['goods_spec'][this.state.info['spec_index']][3][this.state.userInfo['rank_id']] ? this.state.info['goods_spec'][this.state.info['spec_index']][3][this.state.userInfo['rank_id']]['goods_price']:this.state.info['goods_spec'][this.state.info['spec_index']][1]}
											</span>
										):(
											<span className="goods-price">￥{this.state.info['goods_price']}</span>
										)}
									</p>
									<div className="height-10"></div>
									<div className="goods-submit-row">
										&nbsp;&nbsp;
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<button className="button button-red button-submit" onClick={()=>this.showOrder()}>确认购买</button>
									</div>
								</div>
								<div className="clear"></div>
							</div>
							<div className="height-30"></div>
							<div className="goods-panel">
								<div className="captain">
									<h3>商品介绍</h3>
								</div>
								<div className="goods-body">
									<div className="goods-content" dangerouslySetInnerHTML={{__html:this.state.info['content']}}>
										
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="clear"></div>
					<div className="height-20"></div>
				</div>
				<Modal
					title="生成订单"
					width={1000}
					visible={this.state.showOrderDialog}
					footer={null}
					onCancel={()=>this.setState({'showOrderDialog':false})}
					>
					<AddGoodsOrder history={this.props.history} onCancel={()=>this.setState({'showOrderDialog':false})} ref={e=>this.addGoodsOrder = e} />
				</Modal>
			</div>
		);
	}
}

